export default {
  'message.loginSuccess': 'Login Success',
  'message.geetestCaptchaError': 'Please wait for the Geetest captcha to load',
  'message.getCaptchaSuccess': 'Get Captcha Success',
  'message.getCaptchaError': 'Get Captcha Error',
  'message.deleteConfirm': 'Are you sure you want to delete?',
  'message.addSuccess': 'Add Success',
  'message.editSuccess': 'Edit Success',
  'message.deleteSuccess': 'Delete Success',
  'message.resetSuccess': 'Reset Success',
  'message.assignSuccess': 'Assign Success',
  'message.operationSuccess': 'Operation Success',
  'message.operationError': 'Operation Error',
  'message.passwordError': 'Two passwords are not consistent',
  'message.selectMenu': 'Please select menu permission',
  'message.selectDept': 'Please select data permission department',
  'message.googleBindSuccess': 'Google Authenticator Bind Success',
  'message.googleBindError': 'Google Authenticator Bind Error',
  'message.googleUnbindSuccess': 'Google Authenticator Unbind Success',
  'message.googleUnbindError': 'Google Authenticator Unbind Error',
  'message.loginExpired': 'Login expired, please login again',
  'message.networkError': 'Network request failed, please try again later',
  'message.changeSuccess': 'Switch Success',
  'message.noPermission': 'You do not have permission to perform this operation',
  'message.transferSuccess': 'Transfer Success',
  'message.transferChildError': 'Cannot drag the node to its own child node',
  'message.updateError': 'Update Error',
  'message.loading': 'Loading...',
  'message.noData': 'No Data',
  'message.transferError': 'Transfer Error',
  'message.getUserDataError': 'Get User Data Error',
  'message.copySuccess': 'Copy Success',
  'message.copyError': 'Copy Failed',
  'message.operationFailed': 'Operation Failed',
  'message.levelReturnScaleError':
    'The return scale of level {levelIndex} must be less than the return scale of level {levelIndex2}',
  'message.levelReturnScaleError1': 'At least one level is required',
  'message.levelReturnScaleError2': 'Please enter the rebate ratio for level {levelIndex}',
  'message.commissionChangeConfirm': 'Participate in return commission prompt',
  'message.commissionChangeConfirmOperation':
    'Please confirm whether to enable participation in return commission for UID {uid}, after which you will receive commission return benefits.',
  'message.commissionChangeConfirmOperationCancel':
    'Please confirm whether to disable participation in return commission for UID {uid}, after which you will no longer receive commission return benefits.',
  'message.passwordUpdateSuccess': 'Password updated successfully',
  'message.noSearchUser': 'No search results, please confirm whether the UID input is correct',
  'message.actualCommissionBenefit': 'Actual commission benefit quantity is based on the number of settled amounts',
  'message.exportSuccess': 'Export Success',
  'message.exportError': 'Export Error',
  'message.cancelPartnerConfirm': 'Please confirm whether to cancel the partner of the user: UID {uid}',
  'message.cancelPartnerConfirm2':
    'After cancellation, you will no longer receive commissions and login to the partner platform system.',
  'message.cancelPartnerConfirmTip': 'Cancel Partner Prompt',
  'message.statusChangeEnableTip': 'Enable Tip',
  'message.statusChangeDisableTip': 'Disable Tip',
  'message.statusChangeDisableOperation':
    'Are you sure you want to disable the invitation link configuration? After disabling, new users will not be able to register and bind friend relationships through the link, and existing users will not be affected. Please proceed with caution!',
  'message.statusChangeEnableOperation':
    'Are you sure you want to enable the invitation link configuration? After enabling, new users will be able to register and bind friend relationships through the link, and existing users will not be affected. Please proceed with caution!',
  'message.statusDeleteOperation': 'The invitation link has registered users, cannot be deleted!',
  'message.statusDeleteDisableOperation': 'The invitation link is enabled, please disable it before deleting!',
  'message.pleaseSelectEnter': 'Please select or enter',
  'message.timeRangeCannotExceedDays': 'The query time range cannot exceed 31 days',
  'message.emailInvalid': 'Please enter a valid email address',
  'message.emailMustBe': 'Please enter a valid email address (must end with @bitbaby.com)',
  'message.telegramInvalid': 'Please enter a valid Telegram account',
  'message.twitterInvalid': 'Please enter a valid Twitter account',
  'message.discordInvalid': 'Please enter a valid Discord account',
  'message.contentCannotBeEmpty': 'Content cannot be empty',
  'message.selfRebateScaleRequired': 'Please enter the self-rebate ratio',
  'message.futuresSelfRebateScaleRequired': 'Please enter the futures self-rebate ratio',
  'message.spotSelfRebateScaleRequired': 'Please enter the spot self-rebate ratio',
  'message.selfRebateScaleExceedsFutures': 'Futures self-rebate ratio cannot exceed the futures rebate ratio',
  'message.selfRebateScaleExceedsSpot': 'Spot self-rebate ratio cannot exceed the level 1 rebate ratio',
};
